import styled, { css } from 'styled-components';

import { media } from 'DesignLibrary/global';
import { cardStyling, selectedRedStyling } from 'DesignLibrary/utils';

export const Content = styled.div`
  > * + * {
    margin-top: var(--sizing-sm);
  }
`;

export const ButtonGrid = styled.div`
  display: flex;
  gap: var(--sizing-xs);

  button {
    flex-grow: 2;
  }
`;

interface WaiveContainerProps {
  isCoverageWaived: boolean;
}

export const WaiveContainer = styled.div<WaiveContainerProps>`
  ${cardStyling}
  padding: var(--sizing-sm);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sizing-sm);

  ${({ isCoverageWaived }) =>
    isCoverageWaived &&
    css`
      ${selectedRedStyling}
    `}

  ${media.TABLET`
    flex-direction: row;
    justify-content: space-between;
    padding: var(--sizing-sm) var(--sizing-md);
  `}
`;

export const WaiveButton = styled.div`
  width: 100%;
  background: var(--colors-red-50);

  ${media.TABLET`
    max-width: var(--sizing-4xl);
  `}
`;
export const ClaimsCard = styled.div`
  hr {
    margin-bottom: 1rem;

    + .paragraph {
      font-size: 0.875rem;
    }
  }

  .claims-numbers {
    font-size: 0.875rem;
    color: var(--colors-alex-ink80);
    font-weight: 300;

    .numbers {
      &:first-child {
        font-size: 1.25rem;
        font-weight: 700 !important;
        color: var(--colors-gray-black);

        span {
          font-size: 0.875rem;
        }
      }

      &:nth-child(2) {
        font-size: 0.875rem;
        color: var(--colors-alex-ink80);
        display: inline-block;
        margin-right: 0.25rem;
        font-weight: 300;
      }
    }
  }
`;
export const ClaimsTitle = styled.div`
  margin-bottom: 1.5rem;

  h5 {
    font-size: 1.25rem;
    font-weight: 700 !important;
    line-height: 1.2;
  }

  span[role='img'] {
    background: var(--colors-blue-50);
    padding: 0.75rem;
    margin-right: 1rem;
    border-radius: 0.5rem;
  }
`;

export const ClaimsLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;

  > div {
    border: 0 !important;
  }
`;
export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: 0px var(--sizing-md) 0px var(--sizing-sm);

  p {
    color: var(--text-gray);
  }
`;
